// extracted by mini-css-extract-plugin
module.exports = {"title-row":"base-modal_title-row__3ZVn8","title":"base-modal_title__1S8JW"};